
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { ApiService } from "../../../Component/services/apiServices";
import AccountHeader from "../../../Component/Header/account_header";
import Footer from "../../../Component/Footer";

const MyOrder = () => {
  const navigate = useNavigate();
  const [OrderData, setOrderdata] = useState([]);
  const [showskeleton, setshowskeleton] = useState(true);
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      ApiService.fetchData("order-list").then((res) => {
        if (res?.status === "success") {
          setOrderdata(res?.orderData);
          setshowskeleton(false)
        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          window.location.href = '/'
        } else {
          setshowskeleton(false)
        }
      }).catch((error) => { })
    }
    didMountRef.current = false;
  });

  const formatMobileNumber = (mobile) => {
    if (!mobile) return "N/A";
    return mobile.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
  };
  return (
    <>
      <AccountHeader heading={'My Orders'}></AccountHeader>
      <div id="appCapsule">
        <div className="p-15">
          {showskeleton ?
            <Skeleton height={300} width={'100%'}></Skeleton>
            :
            OrderData?.length > 0 ? (
              OrderData?.map((items, index) => {
                return (
                  <div className="info-delivery" key={index} style={{ paddingBottom: "10px" }}>
                    <div className="order-card">
                      <h3 className="order-title">{items?.trans_user_name ?? "N/A"}</h3>
                      <p className="order-info">
                        <strong>Email:</strong> {items?.trans_user_email ?? "N/A"}
                      </p>
                      <p className="order-info">
                        <strong>Mobile:</strong> {items?.trans_user_mobile ?? "N/A"}
                      </p>

                      <div className="order-divider"></div>

                      <p className="order-info">
                        <strong>Order ID:</strong> #{items?.trans_order_number ?? "N/A"}
                      </p>
                      <p className="order-info">
                        <strong>Order Date:</strong>{" "}
                        {moment(items?.created_at).format("MMM D, YYYY")}
                      </p>
                      <p className="order-info">
                        <strong>Order Type:</strong> {items?.trans_delivery_type ?? "N/A"}
                      </p>

                      {items?.trans_delivery_type === "Pickup" ? (
                        <>
                          <p className="order-info">
                            <strong>Pickup Address:</strong> {items?.trans_store_details?.store_address ?? "N/A"}
                          </p>
                          <p className="order-info">
                            <strong>Phone Number:</strong> {formatMobileNumber(items?.trans_store_details?.store_mobile)}
                          </p>
                        </>
                      ) : (
                        <p className="order-info">
                          <strong>Delivery Address:</strong> {items?.trans_delivery_address ?? "N/A"}
                        </p>
                      )}
                      <Link to={`/order-details/${items?.trans_order_number}`} className="btn btn-full btn-primary btn-lg">View Details</Link>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="noimg text-center">
                <img
                  src="/img/no-orders.webp"
                  className="mb-5"
                  style={{ width: "250px" }}
                  alt="Daadi's Kitchen"
                />
                <h5 className="mb-0">No Order Found</h5>
                <p>Look! Like you have not ordered yet</p>

                <button
                  className="btn btn-outline-primary btn-md"
                  type="button"
                  onClick={() => {
                    navigate("/order-online");
                  }}
                >
                  Order Now
                </button>
              </div>
            )}
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default MyOrder;
